// extracted by mini-css-extract-plugin
module.exports = {"container":"e_AP","icon":"e_BP","pathBg":"e_CP","pathFg":"e_DP","variantViolet":"e_EP","variantBase":"e_FP"};